const aceUIError = atex.aceui.error;

export default (node) => {
  if (node.statusCode !== 200) {
    if (node.statusCode === 403) {
      node.disabled = node.statusCode === 403;
    } else {
      node.name = `${node.name} [${node.statusMessage}]`;

      node.error = aceUIError.Error({
        type: atex.aceui.error.types.RUNTIME,
        severity: atex.aceui.error.severities.MINOR,
        origin: 'process-node',
        cause: `${node.name}` || 'Error loading structure'
      });
    }
  }

  return node;
};
